module.exports = __webpack_public_path__ + "static/media/verdeGun.845233a4.jpg";